import { erc20Abi, encodeFunctionData } from 'viem';
import { encodeERC7821Execute } from '../utils/encodeERC7821Execute';
export async function withdrawAppFunds(params) {
    const { smartAccount, appRegistryDapp, fnArgs } = params;
    const { appAddress, recipient, signer, currencyAddress, balance } = fnArgs;
    if (!appRegistryDapp) {
        throw new Error('appRegistryDapp is required for withdrawAppFunds operation.');
    }
    let callData;
    if (currencyAddress) {
        // Encode the ERC20 transfer call
        const transferData = encodeFunctionData({
            abi: erc20Abi,
            functionName: 'transfer',
            args: [recipient, balance],
        });
        // Wrap in ERC7821 execute call (SimpleApp inherits from ERC7821)
        callData = encodeERC7821Execute([{ to: currencyAddress, data: transferData }]);
    }
    else {
        // For native ETH, use the existing withdrawETH function
        const simpleApp = appRegistryDapp.callApp(appAddress);
        callData = simpleApp.interface.encodeFunctionData('withdrawETH', [
            recipient,
        ]);
    }
    return smartAccount.sendUserOp({
        toAddress: [appAddress],
        callData: [callData],
        signer,
        spaceId: undefined,
        functionHashForPaymasterProxy: 'unsponsored',
    });
}
